function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { Icon } from "../";
import { AmericanExpressBadge, DiscoverBadge, MastercardBadge, VisaBadge } from "./Assets";
export const CreditCardBadge = ({
  type,
  ...props
}) => {
  switch (type) {
    case "amex":
      return /*#__PURE__*/React.createElement(AmericanExpressBadge, props);

    case "discover":
      return /*#__PURE__*/React.createElement(DiscoverBadge, props);

    case "mastercard":
      return /*#__PURE__*/React.createElement(MastercardBadge, props);

    case "visa":
      return /*#__PURE__*/React.createElement(VisaBadge, props);

    default:
      return /*#__PURE__*/React.createElement(CreditCardIcon, _extends({
        form: true,
        name: "CreditCard"
      }, props));
  }
};
const CreditCardIcon = styled(Icon)`
  width: 24px;
  height: 24px;
`;